module.exports = ".login{min-height:100vh;overflow:hidden;background-color:aliceblue;background-size:100%}.login .login-panel{padding-top:0px}\n"